import React from "react";
import HoneyAsset from "../../images/socialmarketplace.jpg";
import ABN from "../../images/abn-service.jpg";
import ACG from "../../images/ACG-banner-bg.jpg";
import GBRNetwork from "../../images/TPN-bg2.jpg";
import { NavLink } from "react-router-dom";
import { Row, Col } from "react-bootstrap";
import "../NetworkOperatorServices/NetworkOperatorServices.css";
import "./OurProductsAndServices.css";

export default function AbnNetworkProduct() {
  const services = [
    {
      title: "Edge.ai Infrastructure",
      subtitle: "Enterprise-grade micro data centers",
      tag: "Infrastructure",
      tagColor: "#2563eb",
      image: "https://images.unsplash.com/photo-1606765962248-7ff407b51667?w=600&auto=format&fit=crop",
      href: "/SDH",
    },
    {
      title: "SDH",
      subtitle: "Layered software architecture stack",
      tag: "Software",
      tagColor: "#7c3aed",
      image: "https://images.unsplash.com/photo-1507238691740-187a5b1d37b8?w=600&auto=format&fit=crop",
      href: "/SDH",
    },
    {
      title: "ABN.Network",
      subtitle: "Connected SMB & business network",
      tag: "Network",
      tagColor: "#059669",
      image: "https://images.unsplash.com/photo-1451187580459-43490279c0fa?w=600&auto=format&fit=crop",
      href: "/ABN",
    },
    {
      title: "DTN.Network",
      subtitle: "Hub-connected mobile distribution network",
      tag: "Production",
      tagColor: "#d97706",
      image: "https://images.unsplash.com/photo-1544197150-b99a580bb7a8?w=600&auto=format&fit=crop",
      href: "/edge-ai-network",
    },
  ];

  return (
    <div
      style={{
        background: "linear-gradient(160deg, #f8fafc 0%, #f1f5f9 100%)",
        padding: "60px 20px 80px",
      }}
    >
      {/* ── Section Header ── */}
      <div style={{ textAlign: "center", marginBottom: "52px" }}>

        {/* Eyebrow pill */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "8px",
            background: "rgba(37,99,235,0.08)",
            border: "1px solid rgba(37,99,235,0.2)",
            borderRadius: "20px",
            padding: "5px 14px",
            marginBottom: "20px",
          }}
        >
          <div
            style={{
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              background: "#2563eb",
              boxShadow: "0 0 6px rgba(37,99,235,0.6)",
            }}
          />
          <span
            style={{
              fontSize: "0.7rem",
              fontWeight: 700,
              color: "#2563eb",
              letterSpacing: "1px",
              textTransform: "uppercase",
            }}
          >
            Platform Components
          </span>
        </div>

        {/* Main heading with gradient highlight */}
        <div style={{ marginBottom: "8px" }}>
          <h2
            style={{
              fontSize: "clamp(1.8rem, 3.5vw, 2.6rem)",
              fontWeight: 900,
              color: "#0f172a",
              margin: "0",
              letterSpacing: "-1px",
              lineHeight: 1.15,
            }}
          >
            EdgeAI{" "}
            <span
              style={{
                background: "linear-gradient(135deg, #2563eb 0%, #059669 100%)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
                backgroundClip: "text",
              }}
            >
              Micro Data Center
            </span>
          </h2>
        </div>

        {/* Subtitle */}
        <p
          style={{
            fontSize: "1rem",
            color: "#64748b",
            maxWidth: "540px",
            margin: "14px auto 0",
            lineHeight: 1.7,
          }}
        >
          A fully integrated stack — from edge hardware to software to connected
          agri-business networks. Own it. Operate it. Earn from it.
        </p>

        {/* Stat strip */}
        <div
          style={{
            display: "inline-flex",
            alignItems: "center",
            gap: "0",
            marginTop: "28px",
            borderRadius: "12px",
            overflow: "hidden",
            border: "1px solid #e2e8f0",
            boxShadow: "0 2px 8px rgba(0,0,0,0.05)",
          }}
        >
          {[
            { value: "4", label: "Core Modules" },
            { value: "1", label: "Unified Stack" },
            { value: "∞", label: "Scale" },
          ].map((stat, i) => (
            <div
              key={i}
              style={{
                padding: "12px 24px",
                background: "#fff",
                borderRight: i < 2 ? "1px solid #e2e8f0" : "none",
                textAlign: "center",
              }}
            >
              <div
                style={{
                  fontSize: "1.3rem",
                  fontWeight: 800,
                  color: "#0f172a",
                  lineHeight: 1,
                  marginBottom: "3px",
                }}
              >
                {stat.value}
              </div>
              <div
                style={{
                  fontSize: "0.65rem",
                  fontWeight: 600,
                  color: "#94a3b8",
                  textTransform: "uppercase",
                  letterSpacing: "0.6px",
                }}
              >
                {stat.label}
              </div>
            </div>
          ))}
        </div>

        {/* Decorative divider */}
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: "10px",
            marginTop: "28px",
          }}
        >
          <div style={{ width: "50px", height: "1px", background: "#cbd5e1" }} />
          <div
            style={{
              width: "6px",
              height: "6px",
              borderRadius: "50%",
              background: "linear-gradient(135deg, #2563eb, #059669)",
            }}
          />
          <div style={{ width: "50px", height: "1px", background: "#cbd5e1" }} />
        </div>
      </div>

      {/* ── Cards Grid ── */}
      <div
        style={{
          display: "grid",
          gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          gap: "24px",
          maxWidth: "1000px",
          margin: "0 auto",
        }}
      >
        {services.map((service, index) => (
          <NavLink
            key={index}
            to={service.href}
            style={{ textDecoration: "none" }}
          >
            <div
              style={{
                background: "#ffffff",
                borderRadius: "16px",
                overflow: "hidden",
                border: "1px solid #e2e8f0",
                boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
                transition: "transform 0.25s ease, box-shadow 0.25s ease",
                cursor: "pointer",
                height: "100%",
                display: "flex",
                flexDirection: "column",
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.transform = "translateY(-6px)";
                e.currentTarget.style.boxShadow = "0 16px 40px rgba(0,0,0,0.12)";
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.transform = "translateY(0)";
                e.currentTarget.style.boxShadow = "0 2px 12px rgba(0,0,0,0.06)";
              }}
            >
              {/* Image */}
              <div
                style={{
                  width: "100%",
                  height: "160px",
                  overflow: "hidden",
                  position: "relative",
                }}
              >
                <img
                  src={service.image}
                  alt={service.title}
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    transition: "transform 0.4s ease",
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.transform = "scale(1.06)";
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.transform = "scale(1)";
                  }}
                />
                {/* Tag overlay */}
                <div
                  style={{
                    position: "absolute",
                    top: "10px",
                    left: "10px",
                    background: service.tagColor,
                    color: "#fff",
                    fontSize: "0.6rem",
                    fontWeight: 700,
                    letterSpacing: "0.6px",
                    textTransform: "uppercase",
                    padding: "3px 9px",
                    borderRadius: "20px",
                    boxShadow: "0 2px 6px rgba(0,0,0,0.2)",
                  }}
                >
                  {service.tag}
                </div>

                {/* Bottom gradient fade on image */}
                <div
                  style={{
                    position: "absolute",
                    bottom: 0,
                    left: 0,
                    right: 0,
                    height: "50px",
                    background: "linear-gradient(to top, rgba(255,255,255,0.6), transparent)",
                  }}
                />
              </div>

              {/* Content */}
              <div
                style={{
                  padding: "16px 18px 20px",
                  display: "flex",
                  flexDirection: "column",
                  flexGrow: 1,
                }}
              >
                {/* Index number */}
                <div
                  style={{
                    fontSize: "0.6rem",
                    fontWeight: 800,
                    color: service.tagColor,
                    letterSpacing: "1px",
                    marginBottom: "4px",
                    opacity: 0.7,
                  }}
                >
                  {String(index + 1).padStart(2, "0")}
                </div>

                <h3
                  style={{
                    fontSize: "1rem",
                    fontWeight: 700,
                    color: "#0f172a",
                    margin: "0 0 6px",
                    letterSpacing: "-0.2px",
                  }}
                >
                  {service.title}
                </h3>
                <p
                  style={{
                    fontSize: "0.8rem",
                    color: "#64748b",
                    margin: "0 0 14px",
                    lineHeight: 1.5,
                    flexGrow: 1,
                  }}
                >
                  {service.subtitle}
                </p>

                {/* CTA row */}
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderTop: "1px solid #f1f5f9",
                    paddingTop: "12px",
                  }}
                >
                  <span
                    style={{
                      fontSize: "0.72rem",
                      fontWeight: 600,
                      color: service.tagColor,
                    }}
                  >
                    Explore →
                  </span>
                  <div
                    style={{
                      width: "24px",
                      height: "24px",
                      borderRadius: "50%",
                      background: `${service.tagColor}15`,
                      border: `1px solid ${service.tagColor}30`,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      fontSize: "0.65rem",
                      color: service.tagColor,
                    }}
                  >
                    ↗
                  </div>
                </div>
              </div>
            </div>
          </NavLink>
        ))}
      </div>
    </div>
  );
}